<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke="currentColor" d="M3.68125 6.65H12.3188V9.3C12.3188 11.1502 10.8189 12.65 8.96875 12.65H7.03125C5.1811 12.65 3.68125 11.1502 3.68125 9.3V6.65Z" stroke-width="1.3"></path>
    <path stroke="currentColor" d="M5.68125 5.0625C5.68125 3.78189 6.71939 2.74375 8 2.74375C9.28061 2.74375 10.3187 3.78189 10.3187 5.0625V6.65H5.68125V5.0625Z" stroke-width="1.3"></path>
    <rect fill="currentColor" x="7.34961" y="8" width="1.3" height="2.5625" rx="0.65"></rect>
  </svg>
</template>
